// extracted by mini-css-extract-plugin
module.exports = {"score-mark":"Nav_score-mark__-Ijej","score-s-mark":"Nav_score-s-mark__dkzoo","nav":"Nav_nav__3TgKz","nav-item":"Nav_nav-item__1QBF5","active":"Nav_active__NJN9m"};